module.exports = __webpack_public_path__ + "hyperion-v2-static/img/no_data_red.ac7d02ae.png";